<footer>
  <div class="upper-footer">
    <div class="container-fluid">
      <div class="upper-footer-ribbon">
        <a href="https://www.selec.com/contact">Get in Touch</a>
      </div>
    </div>
  </div>
  <div class="middle-footer">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-4">
          <div class="footer-number">
            <p>Selec HR Team</p>
            <a href="tel:022-41418459">022-41418459/466/496</a>
          </div>
          <div class="footer-address">
            <p>EL-27/1, Electronic Zone, TTC Industrial Area, MIDC, Mahape, Navi Mumbai - 400 710, Maharashtra.</p>
            <a href="mailto:career@selec.com">Email: career@selec.com</a>
          </div>
        </div>
        <div class="col-md-3">
          <div class="footer-menu">
            <h3>About Selec</h3>
          </div>
          <div class="footlink">
            <a href="https://www.selec.com/about">About Us</a><br>
            <a href="https://www.selec.com/about/global-network">Global Network</a><br>
            <a href="https://www.selec.com/privacy-policy">Privacy Policy</a><br>
            <a href="https://www.selec.com/cookies-policy">Cookies Policy</a><br>
            <a href="https://www.selec.com/terms-conditions">Terms and Conditions</a>
          </div>
        </div>
        <div class="col-md-3">
          <div class="footer-menu">
            <h3>Quick Links</h3>
          </div>
          <div class="footlink">
            <a href="https://www.selec.com/contact">Contact Us</a><br>
            <a href="https://www.selec.com/datasheet">Download Center</a><br>
            <a href="https://www.selec.com/catalog">Catalog</a><br>
            <a href="https://www.selec.com/sitemap">Site Map</a><br>
            <a href="https://www.selec.com/csr">CSR</a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="bottom-footer">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-6">
          <div class="copy">© Copyright 2024. All Rights Reserved | Powered by <a target="_blank" href="https://zwayam.com">
            <img src="assets/zwa.png" loading="lazy" alt="Copyright" width="87" height="29"></a>
          </div>
        </div>
        <div class="col-md-6">
          <div class="social-links">
            <a aria-label="Social" href="https://www.facebook.com/seleccontrol" target="_blank" class="facebook-color"><i class="fa-brands fa-facebook-f"></i></a>
            <a aria-label="Social" href="https://www.youtube.com/c/SelecControlsvideos" target="_blank" class="youtube-color"><i class="fa-brands fa-youtube"></i></a>
            <a aria-label="Social" href="https://www.instagram.com/seleccontrols/" target="_blank" class="insta-color"><i class="fa-brands fa-instagram"></i></a>
            <a aria-label="Social" href="https://www.linkedin.com/company/selec-controls-pvt--ltd-" target="_blank" class="linkedin-color"><i class="fa-brands fa-linkedin-in"></i></a>
            <a aria-label="Social" href="https://twitter.com/SelecControls" target="_blank" class="twitter-color"><i class="fa-brands fa-x-twitter"></i></a>
          </div>
        </div>
      </div>
    </div>
  </div>
</footer>